import gql from 'graphql-tag';
import { Fragments } from '@shared/api';

export const listCards = gql`
  query ListCardsQuery($input: ListCards!) {
    list: listCards(input: $input) {
      hasMore
      totalResults
      cards {
        ...Card
      }
    }
  }

  ${Fragments.card.card}
`;

export const getCards = gql`
  query GetCardsQuery($input: GetCards!) {
    getCards(input: $input) {
      id
      name
    }
  }
`;

export const details = gql`
  query CardDetailsQuery($id: UUID!) {
    card: getCard(id: $id) {
      ...Card
    }
  }

  ${Fragments.card.card}
`;

export const listRelatedCardRollups = gql`
  query ListRelatedCardRollupsQuery($input: ListRelatedCardRollups!) {
    listRelatedCardRollups(input: $input) {
      channelId
      channelName
      channelImageUrl
      cardCount
    }
  }
`;

export const listRelatedCards = gql`
  query ListRelatedCardsQuery($input: ListRelatedCards!) {
    listRelatedCards(input: $input) {
      id
      name
    }
  }
`;

export const chatThread = gql`
  query CardChatThreadQuery($id: UUID!) {
    thread: getThread(id: $id) {
      ...Thread
    }
  }

  ${Fragments.thread.thread}
`;

export const chatInput = gql`
  query CardChatInputQuery($id: UUID!) {
    card: getCard(id: $id) {
      id
      name
      fields
      threadId
    }
  }
`;

export const listCardFieldStringTags = gql`
  query ListCardFieldStringTagsQuery($input: ListCardFieldStringTags!) {
    tags: listCardFieldStringTags(input: $input) {
      ...TagOption
    }
  }

  ${Fragments.card.tag}
`;

export const workflowList = gql`
  query WorkflowListQuery {
    list: listWorkflowListItems {
      ...WorkflowListItem
    }
  }

  ${Fragments.card.workflowListItem}
`;

export const listFragmentTemplates = gql`
  query ListFragmentTemplatesQuery($input: ListCardFragmentTemplates!) {
    listCardFragmentTemplates(input: $input) {
      ...FragmentTemplate
    }
  }

  ${Fragments.card.fragmentTemplate}
`;

export const listSummaryCards = gql`
  query ListSummaryCardsQuery($input: ListSummaryCards!) {
    listSummaryCards(input: $input) {
      hasMore
      cards {
        id
        name
      }
    }
  }
`;

export const getSummaryCards = gql`
  query GetSummaryCardsQuery($input: GetSummaryCards!) {
    getSummaryCards(input: $input) {
      id
      name
    }
  }
`;

export const getEntityAuditTrail = gql`
  query GetEntityAuditTrailQuery($input: GetEntityAuditTrail!) {
    trail: getEntityAuditTrail(input: $input) {
      entityAuditTrailEvents {
        id
        timestamp
        userId
        originUserId
        workflowTemplateId
        cardId
        entries {
          id
          componentId
          componentType
          change {
            ...AnyComponentDataChange
          }
        }
      }
      refs {
        ...EntityRefs
      }
    }
  }

  ${Fragments.entity.EntityRefs}
  ${Fragments.card.change}
`;
